var Ribbon_default = {
  "ribbon": "FEjxq",
  "ribbonText": "_7Sq3g",
  "imageRibbon": "_9yFI6"
};
export {
  Ribbon_default as default
};
//# sourceMappingURL=Ribbon-scss.js.map
